import { render, staticRenderFns } from "./moreExhibitions.vue?vue&type=template&id=5fd8e4cf&scoped=true&"
import script from "./moreExhibitions.vue?vue&type=script&lang=js&"
export * from "./moreExhibitions.vue?vue&type=script&lang=js&"
import style0 from "./moreExhibitions.vue?vue&type=style&index=0&id=5fd8e4cf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd8e4cf",
  null
  
)

export default component.exports